import { AgreementsStrategyConfig } from './agreements-config.interface';
import { developConfig } from './develop.config';
import { localConfig } from './local.config';
import { productionConfig } from './production.config';
import { stagingConfig } from './staging.config';
import { Environment, environment } from '@repo/environment';

let agreementsConfig: AgreementsStrategyConfig;

switch (environment) {
  case Environment.PRODUCTION:
    agreementsConfig = productionConfig;
    break;
  case Environment.DEVELOPMENT:
    agreementsConfig = developConfig;
    break;
  case Environment.LOCAL:
  case Environment.TEST:
    agreementsConfig = localConfig;
    break;
  default:
    agreementsConfig = stagingConfig;
}

export default agreementsConfig;
